import {CommonMessages} from '../common.messages';

export const PanelSettingsGroupsEditDetailsMessages = {
    UpdateTradingGroupStatusFailed: {
        key: 'UpdateTradingGroupStatusFailed',
        message: 'Error while processing request to the server. Unable to update group status.'
    },
    GetTradingGroupStatusTriggersFailed: {
        key: 'GetTradingGroupStatusTriggersFailed',
        message: 'Error while processing request to the server. Unable to get the new available group statuses.'
    },
    ...CommonMessages
};
